export function createDeferredPromise<T>() {
  let localResolve: (value: T) => void = () => undefined
  const promise = new Promise<T>(resolve => (localResolve = resolve))
  return { promise, resolve: localResolve }
}
